export enum ICustomerEnvironmentStatus {
  PENDING = 'pending',
  READY = 'ready',
  DEPLOYING_INFRA = 'deploying_infra',
  DISABLING_INFRA = 'disabling_infra',
  PLANNING_INFRA = 'planning_infra',
  DEPLOYING_MODULES = 'deploying_modules',
  DELETING_INFRA = 'deleting_infra',
  FAILED = 'failed',
  DELETED = 'deleted',
  UNKNOWN = 'unknown',
}

// These customer states are safe to launch SSH sessions. Other states may or may not support SSH, depending
export const SafeCustomerEnvironmentStatus: string[] = [
  ICustomerEnvironmentStatus.READY,
  ICustomerEnvironmentStatus.DEPLOYING_MODULES,
];

export default ICustomerEnvironmentStatus;
